import React from 'react';
import { FadeIn } from './FadeIn';
import { ChevronRight } from 'lucide-react';
export function PainPoints() {
  const pains = ['Pasás horas buscando y adaptando materiales antes de cada sesión.', 'Repetís las mismas actividades porque no tenés tiempo de armar nuevas.', 'Te faltan recursos visuales pensados para distintas edades.', 'Sostener la atención y la propuesta sin improvisar se vuelve cuesta arriba.'];
  return <section className="pt-6 pb-10 px-3" data-id="element-190">
      <div className="max-w-3xl mx-auto" data-id="element-191">
        <FadeIn data-id="element-192">
          <h2 className="text-center font-display text-xl md:text-2xl font-bold text-accent mb-6" data-id="element-193">
            Lo que pasa antes de cada sesión
          </h2>
        </FadeIn>

        <div className="space-y-3" data-id="element-194">
          {pains.map((pain, idx) => <FadeIn key={idx} delay={0.08 * idx} data-id="element-195">
              <div className="flex items-center gap-3 bg-surface border border-accent/10 rounded-lg px-4 py-3" data-id="element-196">
                <ChevronRight className="text-accent/60 shrink-0" size={18} data-id="element-197" />
                <p className="text-ink/85 text-sm md:text-base font-medium" data-id="element-198">
                  {pain}
                </p>
              </div>
            </FadeIn>)}
        </div>

        <FadeIn delay={0.4} data-id="element-199">
          <p className="text-center text-base md:text-lg max-w-2xl mx-auto font-medium text-muted mt-8" data-id="element-200">
            No es falta de compromiso.{' '}
            <span className="text-accent font-bold" data-id="element-201">
              Es falta de un sistema organizado.
            </span>
          </p>
        </FadeIn>
      </div>
    </section>;
}